import React, { useContext } from 'react'
import { Button, ListMenu, ListMenuButton, Spacer, TabMenu, TabMenuButton, View } from 'oio-react'
import { Redirect, Route, Switch, useRouteMatch, useParams } from 'react-router-dom'
import { AddIcon, VisibilityIcon } from 'assets/icons'
import appsConstants from 'config/constants/apps'
import { adminUrl, appUrl } from 'config/constants/urls'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'
import Popover from 'src/components/utils/Popover'
import ThemeContext from 'src/libraries/contexts/Theme'
import { useOrganization } from 'src/graphql/hooks'
import About from './About'
import InitiativeListing from './InitiativeListing'

const AppSettings = () => {
   const { appId } = useParams()
   const match = useRouteMatch()
   const theme = useContext(ThemeContext)

   const { organization } = useOrganization()
   const app = organization.apps.find(a => a.id === appId)
   const appInitiativeClass = appsConstants.find(a => a.type === app.type).initiativeClass
   const appInitiativeTypes = organization.initiativeTypes
      .filter(t => t.enabled && t.class === appInitiativeClass)

   return (
      <View>
         <ProtoReturnBar
            display="block[a-c] none[d-f]"
            returnLinkName="Admin Workspace"
            returnLinkTo={adminUrl}
         />
         <View display="flex" justifyContent="center" width="100%">
            <View
               width="100%"
               maxWidth="100%[a-c] 660px[d-f]"
               padding="20px[a] 25px[b] 30px[c] 40px[d-f]">
               <View width="100%">
                  <View width="100%" display="flex">
                     <View flex="1 1 auto" paddingRight="30px">
                        <ProtoHeadingBlock
                           title={app.name}
                           description={`Configure and manage the ${app.name} app and its content. You can also further customize this App through the "About this App" tab.`}
                        />
                     </View>
                     <View display="flex" flex="0 0 auto" paddingTop="30px">
                        <Button
                           linkTo={appUrl(app)}
                           width="120px"
                           type="submit"
                           name="View App"
                           color="#ddd"
                           textColor="#333"
                           size="md"
                           textSize="0.9"
                           padding="20px">
                           <View display="flex" alignItems="center" marginRight="5px">
                              <VisibilityIcon
                                 width="16px"
                                 height="16px"
                                 color="#333"
                                 strokeWidth="2px"
                              />
                           </View>
                        </Button>
                        <Spacer orientation="vertical" size="1" />
                        <Popover.Provider>
                           <Popover.Anchor>
                              <Button
                                 width="30px"
                                 type="submit"
                                 color={theme.protoSettingsHighlightBackgroundColor}
                                 textColor={theme.protoSettingsHighlightForegroundColor}
                                 size="md"
                                 textSize="0.9"
                                 padding="0px">
                                 <AddIcon
                                    color={theme.protoSettingsHighlightForegroundColor}
                                    width="12px"
                                    height="12px"
                                    strokeWidth="4px"
                                 />
                              </Button>
                           </Popover.Anchor>
                           <Popover.View
                              anchorOriginHorizontal="right"
                              anchorOriginVertical="top"
                              backgroundColor="#fff"
                              borderRadius="3px"
                              margin="-10px 0px"
                              width="180px">
                              <View
                                 float="left"
                                 width="100%"
                                 borderRadius="3px"
                                 boxShadow="3px 3px 12px rgba(0,0,0,0.2)"
                                 backgroundColor="#fff">
                                 <ListMenu buttonSize="md" buttonTextColor="#333">
                                    {appInitiativeTypes.map(type => (
                                       <ListMenuButton
                                          key={type.id}
                                          name={`New ${type.nameSingular}`}
                                          linkTo={`${match.url}/active/create/${type.id}`}
                                       />
                                    ))}
                                 </ListMenu>
                              </View>
                           </Popover.View>
                        </Popover.Provider>
                     </View>
                  </View>
                  <Spacer size="3" />
                  <TabMenu
                     backgroundColor="#f5f5f5"
                     buttonPaddingHorizontal="0px"
                     buttonSpacing="24px">
                     <TabMenuButton
                        name="About this App"
                        linkTo={`${match.url}/about`}
                     />
                     <TabMenuButton
                        name="Active"
                        linkTo={`${match.url}/active`}
                     />
                     <TabMenuButton
                        name="Archived"
                        linkTo={`${match.url}/archived`}
                     />
                  </TabMenu>
                  <Switch>
                     <Redirect exact from={match.path} to={`${match.path}/about`} />
                     <Route
                        path={`${match.path}/:initiativeStatus(active|archived)`}
                        component={InitiativeListing}
                     />
                     <Route path={`${match.path}/about`} component={About} />
                  </Switch>
               </View>
            </View>
         </View>
      </View>
   )
}

export default AppSettings
